  <template lang="pug">
.crud
  modal-import(model="label_groups")
  modal-label-groups(:form='form', :is-add='isModalAdd')
  modal-label-products(:form='form', :is-add='isModalAdd')
  modal-label-orders(:form='form', :is-add='isModalAdd')
  modal-label-transfers(:form='form', :is-add='isModalAdd')
  modal-label-products-by-excel
  modal-label-products-by-order(:form='form')
  div#parent.container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.label_generator') }}:
          span {{ $t('strings.label_generator_description') }}
        div(style="display:none;")
          vm-button(type="default" icon="list")
          vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
        div
          vm-button(icon="printer" @click="openShipments") {{ $t('label_groups.from_shipment') }}
        div
          vm-button(icon="printer" @click="openTransfers") {{ $t('label_groups.from_transfer') }}
        div
          vm-button(icon="printer" @click="openByExcel") {{ $t('label_groups.from_excel') }}
        div
          vm-button(icon="printer" @click="openByOrder") {{ $t('label_groups.from_order') }}
      vm-col.padding-vertical(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        vm-input#code.padding(:placeholder="$t('products.code')" v-model="productCode" @keyup.enter="findByCode()")
        h2.padding /
        type-ahead-select(@item-select="selectProduct" @search="autoCompleteFunc" :data="products" showColumn='name' :isSFS="isSFS" isProducts=true)
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(max-height="350px" :data="labels")
          template(slot="header")
            vm-col(vm-type="flex" vm-align="center" vm-lg=1 vm-sm=1)
              h2 {{ $t('strings.labels') }}
            vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=11 vm-sm=11)
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('label_groups.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column != 'code' && column != 'name' && column != 'description' && column != 'quantity' && column != 'products_by_label'") {{data[indextr][column]}}
                slot(v-if="column == 'code'")  {{ data[indextr].code }}
                slot(v-if="column == 'name'")  {{ data[indextr].name }}
                .input__wrapper(v-if="column == 'quantity'")
                  vm-input(:id ="'inputQuantity'+indextr" v-if="fromOrder" v-model="data[indextr].quantity" :danger="$v.labels.$each[indextr].quantity.$invalid" :danger-text="$t('validation.quantity_incorrect')" @keyup="checkValueQuantity(data[indextr])" @keypress="checkValueQuantity(data[indextr])" @keyup.enter="focusProductsByLabels(indextr)" type="number")
                  vm-input(:id ="'inputQuantity'+indextr" v-if="!fromOrder" v-model="data[indextr].quantity" :danger="$v.labels.$each[indextr].quantity.$invalid" :danger-text="$t('validation.quantity_incorrect')" @keyup.enter="focusProductsByLabels(indextr)" type="number")
                .input__wrapper(v-if="column == 'products_by_label'")
                  vm-input(:id ="'inputProductsByLabel'+indextr" v-if="fromOrder" v-model="data[indextr].products_by_label" :danger="$v.labels.$each[indextr].products_by_label.$invalid" :danger-text="$t('validation.products_by_label_incorrect')" @keyup="checkValueByLabel(data[indextr])" @keypress="checkValueByLabel(data[indextr])" @keyup.enter="focusQuantity(indextr)" type="number")
                  vm-input(:id ="'inputProductsByLabel'+indextr" v-if="!fromOrder" v-model="data[indextr].products_by_label" :danger="$v.labels.$each[indextr].products_by_label.$invalid" :danger-text="$t('validation.products_by_label_incorrect')" @keyup.enter="focusQuantity(indextr)" type="number")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteLabelConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
        transition(name="enter")
        .floating_button
          vm-button(icon="printer" @click="print" :disabled="!labels.length > 0") {{ $t('label_groups.print') }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
import alertAudio from '../../public/sounds/alert.mp3'
import parserFilters from '@/utils/parserFilters'

import { required, minValue, integer } from 'vuelidate/lib/validators'
const { mapGetters, mapActions } = createNamespacedHelpers('LabelGroups')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalLabelGroups = () => import('@/components/modals/ModalLabelGroups.vue')
const ModalLabelProducts = () => import('@/components/modals/ModalLabelProducts.vue')
const ModalLabelOrders = () => import('@/components/modals/ModalLabelOrders.vue')
const ModalLabelTransfers = () => import('@/components/modals/ModalLabelTransfers.vue')
const ModalLabelProductsByExcel = () => import('@/components/modals/ModalLabelProductsByExcel.vue')
const ModalLabelProductsByOrder = () => import('@/components/modals/ModalLabelProductsByOrder.vue')
const TypeAheadSelect = () => import('@/components/elements/TypeAheadSelect.vue')

export default {
  name: 'LabelGroups',
  components: {
    ModalImport,
    ModalLabelGroups,
    ModalLabelProducts,
    ModalLabelOrders,
    ModalLabelTransfers,
    ModalLabelProductsByExcel,
    ModalLabelProductsByOrder,
    TypeAheadSelect
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    keyNumber: 0,
    productCode: '',
    productDescription: '',
    lastInput: 0,
    columns: [
      'product_code_display',
      'product_display',
      'quantity',
      'products_by_label'
    ],
    columnsOrderBy: ['code', 'description'],
    attributeModal: 'code',
    status: [],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        code: '',
        description: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  validations () {
    return {
      labels: {
        $each: {
          products_by_label: {
            required,
            decimalWithTwoDecimals: value => /^-?\d+(\.\d{1,2})?$/.test(value),
            minValue: minValue(1)
          },
          quantity: {
            required,
            integer,
            minValue: minValue(1)
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'labelGroups',
      'products',
      'pagination',
      'filterParams',
      'labels',
      'fromOrder',
      'products',
      'syncro',
      'order',
      'transferFolio'
    ]),
    ...configMapGetters(['isSFS'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'getProducts',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'findProduct',
      'findProductByDescription',
      'deleteLabel',
      'getShipments',
      'getTransfers',
      'printTag',
      'addLabels',
      'setProductsByExcelModalVisible',
      'setProductsByOrderModalVisible',
      'setLoader',
      'checkSyncro',
      'syncContpaqOrders'
    ]),
    findByCode () {
      this.findProduct({ code: this.productCode }).then(t => {
        this.productCode = ''
        const quantityLabelsFound = t
        if (!quantityLabelsFound) {
          this.playAlertSound()
          this.$vm.dialog({
            color: 'danger',
            title: this.$t('label_groups.not_found'),
            text: this.$t('label_groups.product_not_found')
          })
        } else {
          this.lastInput = this.labels.length
          this.sendLastQuantityInput()
          window.scrollTo(0, document.body.scrollHeight)
        }
      })
    },
    openShipments () {
      this.getShipments()
    },
    openTransfers () {
      const filters = {
        whereIn: {
          status_transfer_id: [2, 5]
        }
      }
      const payload = {
        page: 1,
        filters: parserFilters(filters)
      }
      this.getTransfers(payload)
    },
    openByExcel () {
      this.setProductsByExcelModalVisible(true)
    },
    openByOrder () {
      this.checkSyncro().then(() => {
        if (this.syncro) {
          this.setProductsByOrderModalVisible(true)
        }
      })
    },
    deleteLabelConfirm (label) {
      let t = this
      this.auxDeleteLabel = () => {
        t.deleteLabel({ code: label.code })
      }
      this.$vm.dialog({
        color: 'primary',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.label'), attribute: this.$t(label.code) }),
        accept: this.auxDeleteLabel
      })
    },
    print () {
      this.setLoader(true)
      this.addRecord({ labels: this.labels }).then(t => {
        this.setLoader(false)
        this.productCode = ''
        this.productDescription = ''
        this.printTag({ id: this.labelGroups[0].id, customer_code: this.order.customer_code, transfer_folio: this.transferFolio })
      })
    },
    checkValueQuantity (item) {
      item.quantity_validation = (parseInt(item.quantity) / parseFloat(item.products_by_label)) !== item.quantity_from_order
    },
    checkValueByLabel (item) {
      if (!(item.quantity_from_order % parseFloat(item.products_by_label))) {
        item.quantity = item.quantity_from_order / parseFloat(item.products_by_label)
        item.by_label_validation = false
      } else {
        item.by_label_validation = true
      }
    },
    focusProductsByLabels (index) {
      document.getElementById('inputProductsByLabel' + index).focus()
    },
    focusQuantity (index) {
      if (this.labels.length > index + 1) { document.getElementById('inputQuantity' + (index + 1)).focus() } else { document.getElementById('code').focus() }
    },
    sendLastQuantityInput () {
      var lastElement = document.getElementById('inputQuantity' + this.lastInput)
      if (lastElement === null) lastElement = document.getElementById('inputQuantity' + (this.lastInput - 1))
      lastElement.focus()
      window.scrollTo(0, document.body.scrollHeight)
    },
    autoCompleteFunc (value) {
      this.getProducts({ filter: `?param=${value},name&order_by=name,asc` })
    },
    selectProduct (product) {
      this.lastInput = this.labels.length
      this.addLabels([product])
      setTimeout(() => this.sendLastQuantityInput(), 500)
    },
    playAlertSound () {
      const alert = new Audio(alertAudio)
      alert.play()
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.floating_button {
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 50px;
  padding: 10px;
  z-index: 20000;
}
.padding {
  padding-left: 10px;
  padding-right: 10px;
}
.input__wrapper,
.actions__wrapper {
  display: flex;
}
.padding-vertical {
  padding-top: 15px;
  padding-bottom: 10px;
}
</style>
